import ZoomPluginConfiguration from './zoomPluginConfiguration';

export default class Plugins {
  zoom: ZoomPluginConfiguration;
}
